import { getCommonInfo } from '@/http/modules/common/privilege'
import { constantRoutes } from '@/router/index.js'
import dealRoutes from '@/help/dealRoutes'
import stuRoutes from '@/router/modules/student.js'

const state = () => ({
    commonInfoFromStore: {},
    routes: [],
    routes_stu: [],
    addRoutes: [],
})

// mutations
const mutations = {
    setCommonInfo(state, data) {
        state.commonInfoFromStore = data
    },
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes =  constantRoutes.concat(routes)
    },
    SET_ROUTES_STU: (state, routes) => {
        state.addRoutes = routes
        state.routes_stu =  constantRoutes.concat(routes)
    },
    RESET_ROUTES: (state) => {
        state.routes = []
        state.routes_stu = []
    }
}

// actions
const actions = {
    getCommonInfoAction({ commit }) {
        return new Promise(resolve => {
          getCommonInfo().then(({ data }) => {
            commit('setCommonInfo', data)
            resolve(data)
          })
        })
    },
    generateRoutes({ commit }) {
        return new Promise(resolve => {
            getCommonInfo().then(({ data }) => {
                const { privilege } = data
                const routes = dealRoutes(privilege)
                commit('SET_ROUTES', routes)
                resolve(routes)
            })
        })
    },
    // 学生端路由
    generateRoutes_Stu({ commit }) {
        return new Promise(resolve => {
            commit('SET_ROUTES_STU', stuRoutes)
            resolve(stuRoutes)
        })
    },
    resetRoutesAction({ commit }) {
        commit('RESET_ROUTES')
    }
}



export default {
    namespaced: true,
    state,
    actions,
    mutations
}
